import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMdrtCenterLogoReverse = props => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <defs><clipPath id="mdrt-center-logo-reverse_svg__a" clipPathUnits="userSpaceOnUse"><path d="M0 151.458h216V0H0Z" /></clipPath></defs>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M0 0a8.766 8.766 0 0 1-8.766-8.766v-53.965A8.766 8.766 0 0 1 0-71.497a8.766 8.766 0 0 1 8.766 8.766v53.965A8.766 8.766 0 0 1 0 0" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(129.41 151.458)" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M0 0h-94.683a8.766 8.766 0 0 1-8.766-8.766 8.766 8.766 0 0 1 8.766-8.766H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(103.449 97.438)" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M0 0h-94.682a8.766 8.766 0 0 1-8.766-8.766 8.765 8.765 0 0 1 8.766-8.766H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(207.234 71.477)" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M0 0a8.766 8.766 0 0 1-8.766-8.766v-53.965A8.766 8.766 0 0 1 0-71.497a8.766 8.766 0 0 1 8.766 8.766v53.965A8.766 8.766 0 0 1 0 0" style={{
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(86.59 71.497)" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M0 0h-25.927a8.766 8.766 0 0 1 0-17.532H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(138.478 19.554)" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M0 0h-25.927a8.766 8.766 0 0 1 0-17.532H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(181.298 123.4)" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path d="M0 0h-25.927a8.766 8.766 0 0 1 0-17.532H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(103.449 149.361)" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <path d="M0 0h-25.927a8.766 8.766 0 0 1 0-17.532H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#aa1a2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(60.628 45.515)" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <path d="M0 0h-51.862a8.766 8.766 0 0 1-8.766-8.766 8.765 8.765 0 0 1 8.766-8.766H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(164.414 45.515)" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M0 0h-51.917a8.739 8.739 0 1 1 0-17.478H0A8.74 8.74 0 0 1 0 0" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(207.261 97.438)" />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <path d="M0 0h-51.862a8.766 8.766 0 0 1-8.766-8.766 8.765 8.765 0 0 1 8.766-8.766H0A8.766 8.766 0 0 1 0 0" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(103.449 123.4)" />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <path d="M0 0h-51.841a8.776 8.776 0 0 1-8.777-8.777 8.776 8.776 0 0 1 8.777-8.776H0A8.777 8.777 0 1 1 0 0" style={{
      fill: "#ff6b0f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(60.618 71.497)" />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <g clipPath="url(#mdrt-center-logo-reverse_svg__a)" transform="matrix(1.33333 0 0 -1.33333 0 201.944)">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}<path d="M0 0h2.749l4.146-9.165c.317-.717.557-1.673.557-1.673h.08s.24.956.518 1.673L12.194 0h2.79l1.354-17.532H13.35l-.838 10.479a7 7 0 0 0 .041 1.197h-.08l-3.786-8.45H6.256L2.47-5.856h-.08s.08-.598.042-1.197l-.838-10.479h-2.989zm-11.754-2.669h-6.057V0h15.142v-2.669h-6.057v-14.863h-3.028z" style={{
        fill: "#fff",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none"
      }} transform="translate(199.662 19.554)" /></g>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== props) {
    t14 = <svg viewBox="0 0 288 201.944" {...props}>{t0}{t13}</svg>;
    $[14] = props;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  return t14;
};
export default SvgMdrtCenterLogoReverse;